/** ISO-3166 alpha-2 codes supported in payer capture (aligned with payment-link / TRIA). */
export const KYC_PAYER_COUNTRY_CODES = [
  "US",
  "MX",
  "VE",
  "CO",
  "AR",
  "BR",
  "CL",
  "PE",
  "EC",
  "BO",
  "ES",
];

const KYC_PAYER_COUNTRY_LABELS = {
  US: "United States",
  MX: "Mexico",
  VE: "Venezuela",
  CO: "Colombia",
  AR: "Argentina",
  BR: "Brazil",
  CL: "Chile",
  PE: "Peru",
  EC: "Ecuador",
  BO: "Bolivia",
  ES: "Spain",
};

export const KYC_PAYER_COUNTRY_OPTIONS = KYC_PAYER_COUNTRY_CODES.map((code) => ({
  value: code,
  label: KYC_PAYER_COUNTRY_LABELS[code],
}));

const LEGACY_COUNTRY_MAP = {
  "united states": "US",
  "united states of america": "US",
  usa: "US",
  mexico: "MX",
  méxico: "MX",
  venezuela: "VE",
  colombia: "CO",
  argentina: "AR",
  brazil: "BR",
  brasil: "BR",
  chile: "CL",
  peru: "PE",
  perú: "PE",
  ecuador: "EC",
  bolivia: "BO",
  spain: "ES",
  españa: "ES",
};

/** Normalize stored country to a KYC alpha-2 code when editing legacy free-text values. */
export function normalizeKycCountryValue(value) {
  const raw = typeof value === "string" ? value.trim() : "";
  if (!raw) return "";

  const upper = raw.toUpperCase();
  if (KYC_PAYER_COUNTRY_CODES.includes(upper)) return upper;

  const mapped = LEGACY_COUNTRY_MAP[raw.toLowerCase()];
  return mapped || "";
}
